var ManageBenefitsTileJS = (function () {
    var initialized = false;

    return {
        Init: function () {
            if (initialized) {
                return;
            }

            //Sorting dates
            $('.manage-benefits-table-sort-button').click(function() {
                const container = $('.manage-benefits-table-body');
                const elems = $('.manage-benefits-table-row');
                const ascending = !$(this).data('ascending');

                elems.sort(function (a, b) {
                    const sortStringA = $(a).find('.manage-benefits-table-day').text();
                    const sortStringB = $(b).find('.manage-benefits-table-day').text();

                    return (ascending ? 1 : -1) * (new Date(sortStringA) - new Date(sortStringB));
                });

                container.html('');
                container.append(elems);
                $(this).data('ascending', ascending);

                const icon = $(this).find('i');
                $(icon).toggleClass('fa-rotate-180');
            });
            
            initialized = true;
        }
    }
})();